import { render } from "./Consultancy.vue?vue&type=template&id=01f7f6a2"
import script from "./Consultancy.vue?vue&type=script&lang=js"
export * from "./Consultancy.vue?vue&type=script&lang=js"

import "./Consultancy.vue?vue&type=style&index=0&id=01f7f6a2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__